import React, { Fragment, useEffect, useState } from 'react'

import './Configuracion.css'

import { faCog } from '@fortawesome/free-solid-svg-icons'

import BotonBack from '../Utiles/BotonBack'
import Subtitulo from '../Utiles/Subtitulo'
import Header from '../Header/Header'

import { withRouter } from 'react-router-dom'

import Swal from 'sweetalert2'

import {
    getConfiguracion,
    updateConfiguracion,
} from '../../Services/configuracionService'
import {
    CONFIGURACION_MENU_LABEL,
    STOCK_NEGATIVO_HELP,
    STOCK_NEGATIVO_LABEL,
    canAccessConfiguracion,
} from './configuracionAccess'

const Configuracion = ({ history }) => {
    let token = JSON.parse(atob(sessionStorage.getItem('token').split('.')[1]))
    let rol = token.authorities[0]

    const [stockNegativo, setStockNegativo] = useState(false)
    const [isLoad, setIsLoad] = useState(true)

    useEffect(() => {
        if (!canAccessConfiguracion(rol)) {
            history.goBack()
            return
        }
        if (isLoad) {
            getConfiguracion()
                .then((res) => {
                    setStockNegativo(!!(res.data && res.data.stockNegativo))
                })
                .catch((error) => {
                    const apiMessage =
                        (error.response &&
                            error.response.data &&
                            (error.response.data.mensaje ||
                                error.response.data.message)) ||
                        'No se pudo cargar la configuración'
                    Swal.fire({
                        toast: true,
                        position: 'top',
                        title: apiMessage,
                        type: 'info',
                        showConfirmButton: false,
                        timer: 1800,
                    })
                })
            setIsLoad(false)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isLoad])

    const handleToggle = async (event) => {
        const nextValue = event.target.checked
        const previous = stockNegativo
        setStockNegativo(nextValue)
        try {
            const res = await updateConfiguracion(nextValue)
            const updated =
                res.data &&
                res.data.configuracion &&
                typeof res.data.configuracion.stockNegativo === 'boolean'
                    ? res.data.configuracion.stockNegativo
                    : nextValue
            setStockNegativo(updated)
        } catch (error) {
            setStockNegativo(previous)
            const apiMessage =
                (error.response &&
                    error.response.data &&
                    (error.response.data.mensaje ||
                        error.response.data.message)) ||
                'No se pudo actualizar la configuración'
            Swal.fire({
                toast: true,
                position: 'top',
                title: apiMessage,
                type: 'info',
                showConfirmButton: false,
                timer: 1800,
            })
        }
    }

    return (
        <Fragment>
            <Header />
            <div className="container-fluid mt-3">
                <div className="alert alert-dismissible alert-secondary d-flex justify-content-between">
                    <BotonBack />
                    <Subtitulo icon={faCog} title={CONFIGURACION_MENU_LABEL} />
                </div>

                <div className="bg-gris p-3 configuracion-stock">
                    <h5 className="mb-3">Stock</h5>
                    <div className="custom-control custom-switch">
                        <input
                            type="checkbox"
                            className="custom-control-input"
                            id="switchStockNegativo"
                            checked={stockNegativo}
                            onChange={handleToggle}
                        />
                        <label
                            className="custom-control-label"
                            htmlFor="switchStockNegativo"
                        >
                            {STOCK_NEGATIVO_LABEL}
                        </label>
                    </div>
                    <p className="text-muted mb-0 mt-2">{STOCK_NEGATIVO_HELP}</p>
                </div>
            </div>
        </Fragment>
    )
}

export default withRouter(Configuracion)
